/*
 * SOPHIOR PDP add-on bundle
 * Checkbox-pattern voor pre-cart cross-sell: laat de bezoeker één of meer add-ons
 * aanvinken, toont één gecombineerd bundle-totaal incl. simulatie van de Shopify
 * automatic discount, en voegt hoofdproduct + alle aangevinkte add-ons in één
 * /cart/add request toe bij submit van de hoofdform.
 */
(function () {
  var blockEls = Array.prototype.slice.call(document.querySelectorAll('[data-addon-block]'));
  if (!blockEls.length) return;

  var blocks = blockEls
    .map(function (el) {
      return {
        el: el,
        checkbox: el.querySelector('[data-addon-checkbox]'),
        variantId: el.dataset.addonVariantId,
        addonPriceCents: parseInt(el.dataset.addonPriceCents, 10) || 0,
        discountCents: parseInt(el.dataset.discountCents, 10) || 0
      };
    })
    .filter(function (b) { return b.checkbox && b.variantId; });

  if (!blocks.length) return;

  var combinedEl = document.querySelector('[data-addon-combined-total]');
  var combinedCompareEl = document.querySelector('[data-addon-combined-compare]');
  var combinedFinalEl = document.querySelector('[data-addon-combined-final]');
  var combinedLabelEl = document.querySelector('[data-addon-combined-label-text]');

  // Prefix uit de blok-instelling; strip een eventueel ingetypt bedrag (bv. "... €2,00")
  // zodat het dynamische bespaarbedrag er niet dubbel achter komt.
  var combinedLabelPrefix = ((combinedEl && combinedEl.dataset.addonCombinedLabel) || 'Combineer en bespaar')
    .replace(/\s*€\s*\d+(?:[.,]\d+)?\s*$/, '')
    .trim();

  var mainPriceCents = parseInt(blockEls[0].dataset.mainPriceCents, 10) || 0;

  function formatMoney(cents) {
    var euros = (cents / 100).toFixed(2).replace('.', ',');
    return '€' + euros;
  }

  function checkedBlocks() {
    return blocks.filter(function (b) { return b.checkbox.checked; });
  }

  function updateCombinedDisplay() {
    if (!combinedEl) return;
    var checked = checkedBlocks();
    if (!checked.length) {
      combinedEl.hidden = true;
      return;
    }
    var sumAddon = 0;
    var sumDiscount = 0;
    checked.forEach(function (b) {
      sumAddon += b.addonPriceCents;
      sumDiscount += b.discountCents;
    });
    var compareCents = mainPriceCents + sumAddon;
    var finalCents = Math.max(0, compareCents - sumDiscount);
    if (combinedCompareEl) combinedCompareEl.textContent = formatMoney(compareCents);
    if (combinedFinalEl) combinedFinalEl.textContent = formatMoney(finalCents);
    if (combinedLabelEl) {
      combinedLabelEl.textContent = sumDiscount > 0
        ? combinedLabelPrefix + ' ' + formatMoney(sumDiscount)
        : combinedLabelPrefix;
    }
    combinedEl.hidden = false;
  }

  blocks.forEach(function (b) {
    b.checkbox.addEventListener('change', updateCombinedDisplay);
  });

  // Reageer op variant-wissel (Dawn publiceert via assets/product-info.js)
  if (typeof subscribe === 'function' &&
      typeof PUB_SUB_EVENTS !== 'undefined' &&
      PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var variant = event && event.data && event.data.variant;
      if (variant && typeof variant.price === 'number') {
        mainPriceCents = variant.price;
        updateCombinedDisplay();
      }
    });
  }

  // Onderschep submit van product-form wanneer minstens één add-on aanstaat —
  // capture phase op document zodat we vóór Dawn's product-form.js bubble-handler firen.
  document.addEventListener('submit', function (evt) {
    var checked = checkedBlocks();
    if (!checked.length) return;

    var form = evt.target;
    if (!form || !form.closest || !form.closest('product-form')) return;

    evt.preventDefault();
    evt.stopImmediatePropagation();

    var submitBtn = form.querySelector('[type="submit"]');
    var spinner = form.querySelector('.loading__spinner');
    var cart = document.querySelector('cart-drawer');

    if (submitBtn) {
      if (submitBtn.getAttribute('aria-disabled') === 'true') return;
      submitBtn.setAttribute('aria-disabled', 'true');
      submitBtn.classList.add('loading');
    }
    if (spinner) spinner.classList.remove('hidden');

    var variantInput = form.querySelector('[name="id"]');
    var quantityInput = form.querySelector('[name="quantity"]');
    var mainVariantId = variantInput ? variantInput.value : '';
    var mainQuantity = quantityInput && quantityInput.value ? quantityInput.value : '1';

    var fd = new FormData();
    fd.append('items[0][id]', mainVariantId);
    fd.append('items[0][quantity]', mainQuantity);
    checked.forEach(function (b, i) {
      fd.append('items[' + (i + 1) + '][id]', b.variantId);
      fd.append('items[' + (i + 1) + '][quantity]', '1');
      // Meet-hygiëne: markeer add-on-regels zodat ATC-rates op productniveau
      // schoon blijven (underscore-property blijft verborgen in cart/checkout
      // en is tot op de orderregel terug te zien)
      fd.append('items[' + (i + 1) + '][properties][_sophior_source]', 'pdp-addon');
    });

    if (cart && typeof cart.getSectionsToRender === 'function') {
      var sectionIds = cart.getSectionsToRender().map(function (s) { return s.id; });
      fd.append('sections', sectionIds.join(','));
      fd.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') {
        cart.setActiveElement(document.activeElement);
      }
    }

    var cartAddUrl = (typeof routes !== 'undefined' && routes.cart_add_url) ? routes.cart_add_url : '/cart/add';

    fetch(cartAddUrl, {
      method: 'POST',
      headers: {
        'Accept': 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: fd
    })
      .then(function (r) {
        if (!r.ok && r.status !== 422) throw new Error('Cart add failed: ' + r.status);
        return r.json();
      })
      .then(function (data) {
        if (data && data.status) {
          // Shopify foutrespons (bv. out of stock) — herstel UI, laat melding aan Dawn over
          if (typeof publish === 'function' && PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartError) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'sophior-addon-bundle',
              productVariantId: mainVariantId,
              errors: data.errors || data.description,
              message: data.message
            });
          }
          return;
        }
        if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(data);
        }
        if (cart && cart.classList && cart.classList.contains('is-empty')) {
          cart.classList.remove('is-empty');
        }
        if (typeof publish === 'function' && PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'sophior-addon-bundle',
            productVariantId: mainVariantId,
            cartData: data
          });
        }
        document.dispatchEvent(new CustomEvent('sophior:cart-updated'));
        if (!cart) {
          /* Alleen zonder cart-element (cart_type 'page'): met drawer heeft
             renderContents() hierboven al ververst én geopend. */
          document.dispatchEvent(new CustomEvent('sophior:open-cart'));
        }
        // Custom pixel-event zodat de GA4-pixel add-on-ATC's apart kan labelen
        if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
          window.Shopify.analytics.publish('sophior_addon_added_to_cart', {
            source: 'pdp-addon',
            variantIds: checked.map(function (b) { return b.variantId; })
          });
        }
      })
      .catch(function (e) {
        console.error('SOPHIOR bundle ATC failed:', e);
      })
      .finally(function () {
        if (submitBtn) {
          submitBtn.removeAttribute('aria-disabled');
          submitBtn.classList.remove('loading');
        }
        if (spinner) spinner.classList.add('hidden');
      });
  }, true);
})();
